import axios from 'axios';

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

export const privateApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

export type PostGreSQLInterval = {
  seconds?: number;
  minutes?: number;
  hours?: number;
  days?: number;
  weeks?: number;
  months?: number;
  years?: number;
};

/**
 * Minimal user information typically used for displaying user details
 * in relations like created_by, updated_by, canceled_by, etc.
 */
export type MinimalUser = {
  id: string;
  title: string | null;
  first_name: string | null;
  last_name: string | null;
  nickname: string | null;
};

export interface ErrorDetail {
  field?: string;
  message: string;
}

export interface ErrorResponse {
  success: false;
  error: {
    code?: string;
    message: string;
    details?: ErrorDetail[];
  };
  status: number;
  timestamp: string;
}

export class ApiError extends Error {
  code?: string;
  details?: ErrorDetail[];
  status: number;
  timestamp: string;

  constructor(errorResponse: ErrorResponse) {
    super(errorResponse.error.message);
    this.name = 'ApiError';
    this.code = errorResponse.error.code;
    this.details = errorResponse.error.details;
    this.status = errorResponse.status;
    this.timestamp = errorResponse.timestamp;
  }
}
